import React from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { Box, Typography, useTheme, Tooltip, Drawer,  useMediaQuery } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import './main.css';
import AppFooter from '../AppFooter';
import { ReactComponent as ManagmentLogo } from '../../assets/images/managment.svg';
import TimeToLeaveIcon from '@mui/icons-material/TimeToLeave';
import AllInboxIcon from '@mui/icons-material/AllInbox';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import WorkIcon from '@mui/icons-material/Work';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import { useSelector } from 'react-redux';
import Progress from '../Loader/Progress ';
const iconSize = 32;

const LeftNavContent = ({ navItems, location, onNavClick}) => (

    <Box sx={{
        width: { xs: 60, md: 90 },
        height: '100vh',
        bgcolor: '#0B3C5D',
        borderTopRightRadius: 4,
        borderBottomRightRadius: 4,
        boxShadow: '0 2px 12px 0 rgba(11, 60, 93, 0.10)',
        py: 2,
        px: { xs: 0.5, md: 1 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'relative',
        zIndex: 20,
        minHeight: '100vh',
        maxHeight: '100vh',
        overflow: 'hidden',
        flexShrink: 0,
    }}>
        <Box sx={{ width: '100%', flex: 1, display: 'flex', flexDirection: 'column', gap: 1, mt: 2, justifyContent: 'flex-start' }}>
            {navItems.map((item) => {
                const isActive = location.pathname === item.path;
                return (
                    <Tooltip title={item.label} placement="right" key={item.label} arrow disableInteractive>
                        <Box
                            onClick={() => { item.onClick(); if (onNavClick) onNavClick(); }}
                            sx={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                py: 1.2,
                                borderRadius: 2,
                                cursor: 'pointer',
                                bgcolor: isActive ? '#D9B310' : 'transparent',
                                color: isActive ? '#0B3C5D' : '#fff',
                                boxShadow: isActive ? '0 2px 8px 0 rgba(217, 179, 16, 0.10)' : 'none',
                                borderLeft: isActive ? '5px solid #D9B310' : '5px solid transparent',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    bgcolor: isActive ? '#D9B310' : '#D9B310',
                                    color: '#0B3C5D',
                                    boxShadow: '0 4px 12px 0 rgba(217, 179, 16, 0.25)',
                                    borderLeft: '5px solid #D9B310',
                                    transform: 'scale(1.05)',
                                },
                            }}
                        >
                            {item.icon}
                            <Typography
                                sx={{
                                    fontSize: 12,
                                    fontWeight: 700,
                                    mt: 0.5,
                                    color: 'inherit',
                                    display: { xs: 'none', md: 'block' },
                                    textAlign: 'center',
                                    letterSpacing: 0.2,
                                }}
                            >
                                {item.label}
                            </Typography>
                        </Box>
                    </Tooltip>
                );
            })}
        </Box>
    </Box>
);

const LeftNav = ({ drawerOpen, onNavClick  }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const currentYear = new Date().getFullYear();
    const {isShippingStaff,isSuperUser,isAdminUser,isWarehouseStaff,loading,accountType,success} = useSelector((state) => state.user) || {};
    const isClient = accountType === 'Client' || accountType === "client" ;



    // Feature visibility flags (rename for clarity)
    const isContainersVisible = (isSuperUser || isClient || isAdminUser || isShippingStaff );
    const isShipmentsVisible = (isSuperUser ||  isShippingStaff || isAdminUser);
    const isBookingsVisible = (isSuperUser ||  isShippingStaff || isAdminUser);
    const isJobsVisible = (isSuperUser ||  isWarehouseStaff || isAdminUser);
    const isManagementVisible = (isSuperUser || isAdminUser);


    
    const navItems = [
        { icon: <DashboardIcon sx={{ fontSize: iconSize }} />, label: 'Dashboard', path: '/', onClick: () => { navigate('/'); } },
        { icon: <TimeToLeaveIcon sx={{ fontSize: iconSize }} />, label: 'Vehicles', path: '/vehicles', onClick: () => { navigate('/vehicles'); } },
        ...(isContainersVisible ? [{ icon: <Inventory2Icon sx={{ fontSize: iconSize }} />, label: 'Containers', path: '/containers', onClick: () => { navigate('/containers'); } }] : []),
        ...(isShipmentsVisible ? [{ icon: <AllInboxIcon sx={{ fontSize: iconSize }} />, label: 'Shipments', path: '/shipments', onClick: () => { navigate('/shipments'); } }] : []),
        ...(isBookingsVisible ? [{ icon: <EditCalendarIcon width={iconSize} height={iconSize} />, label: 'Booking', path: '/booking', onClick: () => { navigate('/booking'); } }] : []),
        ...(isJobsVisible ? [{ icon: <WorkIcon sx={{ fontSize: iconSize }} />, label: 'Jobs', path: '/jobs', onClick: () => { navigate('/jobs'); } }] : []),
        ...(isManagementVisible ? [{ icon: <ManagmentLogo width={iconSize} height={iconSize} />, label: 'Management', path: '/management', onClick: () => { navigate('/management'); } }] : []),
    ];

    if (loading || !success) {
        <Progress Msg='Loading...'   />
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', height: '100vh', minHeight: '100vh', width: '100vw', overflow: 'hidden' }}>
            {/* Sidebar for desktop */}
            {!isMobile && (
                <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', justifyContent: 'space-between' }}>
                    <Box>
                        <LeftNavContent navItems={navItems} location={location} />
                    </Box>
                    <Box sx={{ width: '100%', mb: 1, px: 1, display: { xs: 'none', md: 'block' } }}>
                        <Typography sx={{ color: '#fff', fontSize: 11, textAlign: 'center', opacity: 0.7 }}>
                            © {currentYear} <a href="https://pinetechs.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#D9B310', textDecoration: 'none' }}>Pinetechs</a>
                        </Typography>
                    </Box>
                </Box>
            )}
            {/* Drawer for mobile */}
            {isMobile && (
                <Drawer
                    anchor="left"
                    open={drawerOpen}
                    onClose={onNavClick}
                    PaperProps={{
                        sx: {
                            width: 60,
                            bgcolor: '#0B3C5D',
                            borderTopRightRadius: 4,
                            borderBottomRightRadius: 4,
                            boxShadow: '0 2px 12px 0 rgba(11, 60, 93, 0.10)',
                            px: 0.5,
                            pt: 5,
                            pb: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            minHeight: '100vh',
                            maxHeight: '100vh',
                            overflow: 'hidden',
                        },
                    }}
                >
                    <LeftNavContent navItems={navItems} location={location} onNavClick={onNavClick} />
                    <Box sx={{ width: '100%', mb: 1, px: 1 }}>
                        <Typography sx={{ color: '#fff', fontSize: 11, textAlign: 'center', opacity: 0.7 }}>
                            © {currentYear} <a href="https://pinetechs.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#D9B310', textDecoration: 'none' }}>Pinetechs</a>
                        </Typography>
                    </Box>
                </Drawer>
            )}
            {/* Content Column: main (scrollable) + footer (fixed at bottom of viewport) */}
            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, height: '100vh', minWidth: 0 }}>
                <Box
                    component="main"
                    sx={{
                        flex: 1,
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        background: '#F7F8FA',
                        pt: { xs: '56px', md: '64px' },
                        px: { xs: 1, md: 3 },
                        pb: 2,
                        transition: 'margin-left 0.2s',
                        borderRadius: { xs: 0, md: 3 },
                        boxShadow: { xs: 'none', md: '0 2px 12px 0 rgba(11, 60, 93, 0.06)' },
                        position: 'relative',
                        zIndex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        minWidth: 0,
                    }}
                >
                    <Outlet />
                </Box>
                <AppFooter />
            </Box>
        </Box>
    );
};

export default LeftNav;
